import { I18n } from '@calendly/i18n'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { IconCopy } from '@calendly/ui/components/glyphs/IconCopy'
import { IconThumbDown } from '@calendly/ui/components/glyphs/IconThumbDown'
import { IconThumbDownFilled } from '@calendly/ui/components/glyphs/IconThumbDownFilled'
import { IconThumbUp } from '@calendly/ui/components/glyphs/IconThumbUp'
import { IconThumbUpFilled } from '@calendly/ui/components/glyphs/IconThumbUpFilled'
import { IconButton } from '@calendly/ui/components/icon-button'

export const IconButtons = ({ onCopy, onLike, onDislike, isLiked, isDisliked }) => (
  <FlexLayout gap="8">
    <IconButton
      data-testid={isLiked ? 'thumb-up-filled' : 'thumb-up-outline'}
      title={{
        text: I18n.t('publisher.agent_hub.good_response'),
        placement: 'bottom'
      }}
      onClick={onLike}
      icon={isLiked ? IconThumbUpFilled : IconThumbUp}
      size="small"
    />
    <IconButton
      title={{
        text: I18n.t('publisher.agent_hub.bad_response'),
        placement: 'bottom'
      }}
      onClick={onDislike}
      icon={isDisliked ? IconThumbDownFilled : IconThumbDown}
      size="small"
    />
    <IconButton
      title={{
        text: I18n.t('publisher.agent_hub.copy'),
        placement: 'bottom'
      }}
      onClick={onCopy}
      icon={IconCopy}
      size="small"
    />
  </FlexLayout>
)
